import React from 'react'
import "./Products6.css"

const Products6 = () => {
  return (
    <div>
      <div className="section19">
        <div className="container19">
            <div className="content-section19">
                <div className="title19">
                    <h1>Our Products</h1>
                </div>
                <div className="content19">
                  <br></br>
                    <h3>Our products are </h3>
                    <h3>  characterized by quality,</h3>
                    <h3> sustainability, and innovation,</h3>
                    <h3>  reflecting our commitment to </h3>
                    <h3> excellence and the </h3>
                    <h3> environment.</h3>
                    {/* <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Inventore odit molestiae dolore autem veniam omnis nobis doloribus, earum doloremque minima?</p> */}
                    <div className="button">
                        {/* <a href="/View3">VIEW MORE</a> */}
                    </div>
                </div>
                <div className="social">
<br></br><br></br><br></br>
                </div>
            </div>
            <div className="image-section19">
                <img src="/images/60.jpg" alt="" />
            </div>
        </div>
      </div>
    </div>
  )
}

export default Products6
